var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-section"},[_c('div',{staticClass:"frame"},[_c('div',{staticClass:"heading"},[_vm._t("heading")],2),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"tail"},[_vm._t("tail")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }